import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { verifyPayment } from "../../core/data/redux/actions/stripeActions";
import { useSearchParams, useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import Lottie from "lottie-react";
import Payment from "../../core/data/img/payment.json";
import Loader from "../../core/data/img/car_loading.json";
import { RootState } from "../../core/data/redux/store";

const PaymentSuccess = () => {
  const routes = all_routes;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [showSuccess, setShowSuccess] = useState(false);

  const { status, loading, error } = useSelector(
    (state: RootState) => ({
      loading: state.stripe.loading,
      error: state.stripe.error,
      status: state.stripe.status,
    })
  );


  useEffect(() => {
    if (sessionId) {
      dispatch(verifyPayment(sessionId));
    }
  }, [sessionId, dispatch]);

  useEffect(() => {
    if (status) {
      setShowSuccess(true);
      setTimeout(() => {
        navigate(routes.bookingSuccess);
      }, 2000);
    }
  }, [status, navigate]);

  return (
    <div>

      {loading && <div className="d-flex justify-content-center align-items-center">
        <Lottie animationData={Loader} loop={true} style={{ width: 300, height: 300 }} />
      </div>}
      {showSuccess &&
        <div className="d-flex justify-content-center align-items-center">
          <Lottie animationData={Payment} loop={true} style={{ width: 600, height: 600 }} />
        </div>}

      {error && error === "Unauthenticated. Please log in."
        && <div className="d-flex justify-content-center align-items-center">
          <Lottie animationData={Payment} loop={true} style={{ width: 600, height: 600 }} />
        </div>}
      {error && error !== "Unauthenticated. Please log in." && <p>{error}</p>}
    </div>
  );
};

export default PaymentSuccess;
